import { createStore } from 'vuex'
import config from '../config'
import axios from 'axios'
import helpers from '../helpers'

export default createStore({
	state: {
		cartypes: [],
		selectedCartypeId: null,
		timerange: {
			start: helpers.addMinutesToNow(24 * 60),
			end: helpers.addMinutesToNow(24 * 60 + config.timerange.defaultDurationMinutes)
		},
		distance: config.defaultDistance,
		tariffs: config.tariffs,
		selectedTariffId: config.tariffs.find(tariff => tariff.id === config.defaultTariffId).id,
		prices: {
			time: 0,
			distance: 0,
			sum: 0
		},
		noPriceAvailable: true
	},
	mutations: {
		fillCartypes(state, payload) {
			state.cartypes = payload.cartypes;
			state.selectedCartypeId = payload.selectedCartypeId;
		},
		setTariff(state, tariff) {
			state.selectedTariffId = tariff.id;
		},
		setCartype(state, cartype) {
			state.selectedCartypeId = cartype.id;
		},
		setTimerange(state, timerange) {
			console.log('setTimerange', timerange.start.getTime(), timerange.end.getTime());
			state.timerange = timerange;
		},
		setDistance(state, payload) {
			state.distance = payload.distance;
		},
		updatePrices(state, newPrices) {
			// zero time hack:
			if (state.timerange.start.getTime() === state.timerange.end.getTime()) {
				newPrices.time = 0;
			}
			newPrices.sum = newPrices.time + newPrices.distance;
			state.prices = newPrices;
		},
		setNoPriceAvailable(state, payload) {
			state.noPriceAvailable = payload.val;
		}
	},
	getters: {
		getTariffs(state) {
			return state.tariffs;
		},
		getSelectedTariffId(state) {
			return state.selectedTariffId;
		},
		getApiKey(state) {
			return state.tariffs.find(tariff => tariff.id === state.selectedTariffId).apikey;
		},
		getCartypes(state) {
			return state.cartypes;
		},
		getSelectedCartypeId(state) {
			return state.selectedCartypeId;
		},
		getTimerange(state) {
			return state.timerange;
		},
		getPrices(state) {
			return state.prices;
		},
		isNoPriceAvailable(state) {
			return state.noPriceAvailable;
		}
	},
	actions: {
		fillCartypes(context) {
			console.log('requesting bookees ...', this.state);
			axios.get('bookees', 
				{
					params: {
						expand: 'bookeeType',
						provId: config.provId,
						start: new Date().toISOString()
					},
					headers: {
						'X-API-Key': context.getters.getApiKey
					}
				})
				.then(function (response) {
					const bookees = response.data;
					const cartypes = [];
					let selectedCartypeId = null;
					bookees.sort((a,b) => {
						return (a.name < b.name) ? -1 : 1;
					});
					bookees.forEach(bookee => {
						const newCartype = {
							id: bookee.id,
							name: bookee.bookeeType.name
						};
						if (bookee.name.indexOf('default') != -1) {
							selectedCartypeId = newCartype.id;
						}
						cartypes.push(newCartype);
					});
					if (!selectedCartypeId) {
						selectedCartypeId = cartypes[0].id;
					}
					console.log('cartypes', cartypes, selectedCartypeId);
					context.commit('fillCartypes', { cartypes: cartypes, selectedCartypeId: selectedCartypeId });
					context.dispatch('updatePrices');
				})
				.catch(error => console.log('api error', error));
		},
		updatePrices(context) {
			console.log('requesting prices ...', this.state);
			axios.post('bookees/' + this.state.selectedCartypeId + '/price', 
				{
					timeRange: this.state.timerange,
					distance: this.state.distance * 1000
				},
				{
					headers: {'X-API-Key': context.getters.getApiKey}
				})
				.then(function (response) {
					const newPrices = { time: 0, distance: 0 };
					if (response.status === 200) {
						response.data.priceItems.forEach(priceItem => {
							if (priceItem.costCategory === 'DRIVING_TIME') {
								newPrices.time = priceItem.priceIncl.amount;
							} else if (priceItem.costCategory === 'DRIVING_DISTANCE') {
								newPrices.distance = priceItem.priceIncl.amount;
							}
						});
						context.commit('setNoPriceAvailable', {val: false});
					} else {
						context.commit('setNoPriceAvailable', {val: true});
					}
					context.commit('updatePrices', newPrices);
				})
				.catch(error => {
					context.commit('updatePrices', { time: 0, distance: 0 });
					console.log('api error', error)
				});
		}
	}
})
